import { createElement as rc, useContext } from 'react';
import { View, styled } from 'lib_ui-primitives';
import { NavbarContext } from '../appLayout/NavBarContextProvider.gl2025';
import propTypes from 'prop-types';

import SideNavContent from './SideNavContent';

const IconMenuArea = styled(View).attrs({ name: 'icon-menu-area' })`
    width: ${({ theme, navLocked }) =>
        theme.mobile ? 0 : navLocked ? theme.titleBar.marginLeft : theme.sideBar?.widthIconOnly}px;
    flex-grow: 0;
    flex-shrink: 0;
    flex-direction: column;
    transition: width 0.3s ease-in-out;
    background-color: ${({ theme }) => theme.titleBar.backgroundColor};
`;
IconMenuArea.displayName = 'IconMenuArea';

/**
 * On the web, we want the option to "reserve" space for the side nav even when it's collapsed.
 * to display the icon-only side nav. And on the web, the nested sidenav will still expand
 * over and out of this space, as it is based on the closest (grand) parent with position: relative.
 *
 * On native, we cannot use this wrapper as it is based on the DIRECT parent of the drawer
 * (the element with position: relative) to determine the max width/position/visibility of the drawer.
 */
function SideNav(props) {
    const { locked: navLocked } = useContext(NavbarContext);

    // prettier-ignore
    return rc(IconMenuArea, { navLocked }, 
        rc(SideNavContent, props)
    );
}

SideNav.propTypes = {
    children: propTypes.node
};
export default SideNav;
